/* eslint-disable no-unused-vars */
import MPSDashboard from "../pages/Dashboard/MPSDashboard";
import ViewEventDetails from "../components/MPS/EventRegistration/ViewEventDetails";
import { CreateEventProvider } from "../context/CreateEventContext";
import ProtectedRoute from "../components/Auth/ProtectedRoute";
import React from "react";
import EventsContent from "../components/MPS/EventsContent";
import SettingsContent from "../components/MPS/SettingsContent";
// Import other MPS components
import { EventProvider } from "../components/MPS/EventContext";
import DashboardContent from "../components/MPS/DashboardContent";
import MPSEventRegistration from "../components/MPS/EventRegistration/MPSEventRegistration";
import { MPSEventRegistrationProvider } from "../context/MPSEventRegistrationContext";
import ViewEventDetailsNew from "../components/MPS/EventRegistration/ViewEventDetailsNew";
import AnnouncementsTab from "../components/MPS/Announcements/AnnouncementsTab";
import PaymentSuccess from "../components/MPS/EventRegistration/PaymentSuccess";
import PaymentCancel from "../components/MPS/EventRegistration/PaymentCancel";
import ReceiptsList from "../components/Receipts/ReceiptsList";
import ReceiptView from "../components/Receipts/ReceiptView";
import SupportContent from "../components/Support/SupportContent";
import TutorialVideos from "../components/Tutorials/TutorialVideos";

export const mpsRoutes = [
  {
    path: "/mps/dashboard",
    element: (
      <EventProvider>
        <CreateEventProvider>
          <MPSDashboard>
            <DashboardContent />
          </MPSDashboard>
        </CreateEventProvider>
      </EventProvider>
    ),
  },
  {
    path: "/mps/announcements",
    element: (
      <ProtectedRoute>
        <EventProvider>
          <CreateEventProvider>
            <MPSDashboard>
              <AnnouncementsTab />
            </MPSDashboard>
          </CreateEventProvider>
        </EventProvider>
      </ProtectedRoute>
    ),
  },
  {
    path: "/mps/view-event-details/:id",
    element: (
      <EventProvider>
        <CreateEventProvider>
          <MPSDashboard>
            <ViewEventDetailsNew />
          </MPSDashboard>
        </CreateEventProvider>
      </EventProvider>
    ),
  },
  {
    path: "/mps/event-registration/:id",
    element: (
      <EventProvider>
        <CreateEventProvider>
          <MPSEventRegistrationProvider>
            <MPSDashboard>
              <MPSEventRegistration />
            </MPSDashboard>
          </MPSEventRegistrationProvider>
        </CreateEventProvider>
      </EventProvider>
    ),
  },
  {
    path: "/mps/events",
    element: (
      <ProtectedRoute>
        <EventProvider>
          <CreateEventProvider>
            <MPSDashboard>
              <EventsContent />
            </MPSDashboard>
          </CreateEventProvider>
        </EventProvider>
      </ProtectedRoute>
    ),
  },
  {
    path: "/mps/settings",
    element: (
      <ProtectedRoute>
        <EventProvider>
          <CreateEventProvider>
            <MPSDashboard>
              <SettingsContent />
            </MPSDashboard>
          </CreateEventProvider>
        </EventProvider>
      </ProtectedRoute>
    ),
  },
  {
    path: "/mps/view-event-details/:id/success",
    element: <PaymentSuccess />,
  },
  {
    path: "/mps/view-event-details/:id/cancel",
    element: <PaymentCancel />,
  },
  {
    path: "/mps/receipts",
    element: (
      <ProtectedRoute>
        <EventProvider>
          <CreateEventProvider>
            <MPSDashboard>
              <ReceiptsList userType="MPS" />
            </MPSDashboard>
          </CreateEventProvider>
        </EventProvider>
      </ProtectedRoute>
    ),
  },
  {
    path: "/mps/receipts/:id",
    element: (
      <ProtectedRoute>
        <EventProvider>
          <CreateEventProvider>
            <MPSDashboard>
              <ReceiptView userType="MPS" />
            </MPSDashboard>
          </CreateEventProvider>
        </EventProvider>
      </ProtectedRoute>
    ),
  },
  {
    path: "/mps/support",
    element: (
      <ProtectedRoute>
        <EventProvider>
          <CreateEventProvider>
            <MPSDashboard>
              <SupportContent />
            </MPSDashboard>
          </CreateEventProvider>
        </EventProvider>
      </ProtectedRoute>
    ),
  },
  {
    path: "/mps/tutorials",
    element: (
      <ProtectedRoute>
        <EventProvider>
          <CreateEventProvider>
            <MPSDashboard>
              <TutorialVideos />
            </MPSDashboard>
          </CreateEventProvider>
        </EventProvider>
      </ProtectedRoute>
    ),
  },
];
